export default {
  compra: {},
};
